var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBeneficios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3467",
    "data-name": "Grupo 3467",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.263,
    height: 24.406,
    viewBox: "0 0 24.263 24.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_509",
    "data-name": "Rect\\xE1ngulo 509",
    width: 24.263,
    height: 24.406,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3466",
    "data-name": "Grupo 3466",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5087",
    "data-name": "Trazado 5087",
    d: "M23.741,14.213a1.788,1.788,0,0,0-2.526,0l-3.034,3.034a1.786,1.786,0,0,0-1.491-.805H8.237a4.387,4.387,0,0,0-3.123,1.293L3.739,19.111a1.523,1.523,0,0,0-1.466.364L.112,21.636a.38.38,0,0,0,0,.539L5.48,27.543a.38.38,0,0,0,.539,0L8.18,25.382a1.464,1.464,0,0,0,.355-1.531l.8-.8a1.041,1.041,0,0,1,.74-.306H16.7a2.519,2.519,0,0,0,1.77-.734l5.269-5.269a1.788,1.788,0,0,0,0-2.527M23.2,16.2,17.932,21.47a1.751,1.751,0,0,1-1.231.51H10.076A1.8,1.8,0,0,0,8.8,22.51l-.686.687-3.69-3.69,1.232-1.232A3.63,3.63,0,0,1,8.237,17.2H16.69a1.024,1.024,0,1,1,0,2.048H12.574a.381.381,0,0,0,0,.763H16.69a1.708,1.708,0,0,0,1.769-1.968l3.3-3.295A1.024,1.024,0,0,1,23.2,16.2",
    transform: "translate(0 -3.249)",
    fill: "#006465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5088",
    "data-name": "Trazado 5088",
    d: "M22.314,12.209a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4",
    transform: "translate(-4.156 -2.328)",
    fill: "#006465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5089",
    "data-name": "Trazado 5089",
    d: "M18.071,2.4A2.4,2.4,0,1,1,15.67,0a2.4,2.4,0,0,1,2.4,2.4",
    transform: "translate(-3.149 0)",
    fill: "#006465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5090",
    "data-name": "Trazado 5090",
    d: "M26.753,3.96a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4",
    transform: "translate(-5.209 -0.37)",
    fill: "#006465"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeneficios);
export default __webpack_public_path__ + "static/media/icon_beneficios.203f7ef1.svg";
export { ForwardRef as ReactComponent };